module.exports = __webpack_public_path__ + "img/car_icon_example.67eca174.png";